import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginRightImageHighlightInfo } from './PluginRightImageHighlightInfo';
import { PluginRightImageHighlightInfoContent } from './PluginRightImageHighlightInfoContent';
import { PluginRightImageHighlightInfoFigure } from './PluginRightImageHighlightInfoFigure';

type Props = {
  index: number;
  data: PluginRightImageHighlightInfo;
  updateData: (element: IElement, index: number) => void;
};

export const PluginRightImageHighlightInfoFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginRightImageHighlightInfo>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-right-image-highlight-info">
          <div className="background" />
          <div className="showcase">
            <PluginRightImageHighlightInfoContent data={data} update={update} />
            <PluginRightImageHighlightInfoFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
